import { Button } from '@/components/atoms/button'
import { ButtonProps } from '@/components/atoms/button/Button'
import { ContactLinkTypes } from '@/types/enums'
import { chakra, HStack } from '@chakra-ui/react'
import { SocialActions } from '@/baseComponents'
import {
  AiOutlineFacebook,
  AiOutlineLinkedin,
  AiOutlineYoutube,
} from 'react-icons/ai'
import { FaXTwitter } from 'react-icons/fa6'
import { MdOutlineAlternateEmail } from 'react-icons/md'
import { RxMobile } from 'react-icons/rx'
import { formatContactUrl } from '@/utils/contactUrlFormatter'

export type ContactIconProps = {
  contactLinkType: ContactLinkTypes
  url: string
  text?: string
  target?: string
}

export type ContactLinksProps = {
  items: ContactIconProps[]
  buttonProps: ButtonProps
}
export default chakra(ContactLinks)
function ContactLinks({ items, buttonProps, ...props }: ContactLinksProps) {
  const SocialIcon = (contactLinkType?: ContactLinkTypes) => {
    if (!contactLinkType) return
    switch (contactLinkType?.toLocaleLowerCase()) {
      case ContactLinkTypes.Facebook:
        return <AiOutlineFacebook />

      case ContactLinkTypes.Linkedin:
        return <AiOutlineLinkedin />

      case ContactLinkTypes.Youtube:
        return <AiOutlineYoutube />

      case ContactLinkTypes.Twitter:
        return <FaXTwitter />

      case ContactLinkTypes.Email:
        return <MdOutlineAlternateEmail />

      case ContactLinkTypes.Phone:
        return <RxMobile />
    }
  }

  return (
    <HStack {...props}>
      {items?.map((item, index) => {
        return (
          <Button
            key={`social-media-buttons-${index}`}
            target={item.target}
            text={item.text}
            url={formatContactUrl(item.contactLinkType, item.url)}
            icon={buttonProps.icon ?? SocialIcon(item.contactLinkType)}
            socialInteractionEventProps={{
              socialAction: SocialActions.LinkClick,
              socialPlatform: item.contactLinkType,
            }}
            {...buttonProps}
          />
        )
      })}
    </HStack>
  )
}
